/* Green Peace · carrito propio en el cajón de Shrine (28/10/2026). Adaptado de assets/md-cart.js de Medicode
   (rapidez, cola, vigilancia y fallos cerrados allí), con lo propio de Green Peace:
   - Subir de tramo [data-gpc-up]: pone la línea del tramo 1 a 3 unidades (/cart/update.js) y Kaching la reparte en
     "Buy 2 Get 1 Free" (2 de pago + 1 gratis), igual que elegir el tramo 2 en la PDP (probado el 28/10). Liquid no ve
     __kaching_bundles, así que la tarjeta sale oculta y aquí se enseña solo si la línea viene de Kaching (main): las
     claves se sacan de las respuestas del carrito y de /cart.js. Sin Kaching, 3 unidades se cobrarían enteras.
   - Sin "+" ni "−" en las tarjetas (la cantidad cambia el tramo): "Remove" quita la tarjeta entera.
   - Complementos [data-gpc-par]: marcar añade la variante con la propiedad _gp_par; desmarcar quita su línea.
   - Protección [data-gpc-prot]: interruptor. Viaja dentro del "Add To Cart" de la ficha cuando toca ponerla; se pone
     sola salvo que el cliente la haya quitado (sessionStorage + atributo del carrito _gpc_prot_off). Si solo queda
     la protección ([data-gpc-huerfana]) se quita; si hay más de una, se deja una.
   - Al instante: casillas, protección, quitar y subir de tramo cambian en pantalla con los importes del HTML
     (data-*); Shopify confirma detrás y el repintado pone lo exacto. Cola: una acción detrás de otra y solo se
     repinta con la última respuesta, conservando el scroll.
   - Pagar: nunca con cambios sin guardar; después va a /checkout (checkout de Shopify).
   - Vigilancia: cualquier petición al carrito de otros (tema, Kaching u otras apps; fetch o XHR) deja el cajón
     pendiente; al calmarse (y al abrir el cajón) se compara con /cart.js y se repinta si no cuadra. En la misma
     revisión se quitan los regalos de Kaching sin su producto.
   Delegación en document: sigue funcionando después de cada repintado. El JS del tema no se toca. */
(() => {
  if (window.gpcCartReady) return;
  window.gpcCartReady = true;

  const OFF = 'gpc-proteccion-off';
  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* sin almacenamiento: se comporta como visita nueva */ } },
  };

  const drawer = () => document.querySelector('cart-drawer');
  const raiz = () => document.querySelector('#CartDrawer .gpc') || document.querySelector('[data-gpc-pagina] .gpc');
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const url = (path) => `${root()}${path}`;

  // página /cart (sections/gp-cart-page): se repinta junto con el cajón
  const pagina = () => {
    const el = document.querySelector('[data-gpc-pagina]');
    const sec = el && el.closest('[id^="shopify-section-"]');
    return sec ? { el, id: sec.id.replace('shopify-section-', '') } : null;
  };
  function sections() {
    const d = drawer();
    const ids = d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map((s) => s.section || s.id) : [];
    const p = pagina();
    if (p) ids.push(p.id);
    return ids;
  }

  // --- líneas que vienen de Kaching (para enseñar "subir de tramo") ---
  const conKaching = new Set();
  const kb = (item) => {
    try { return JSON.parse((item.properties || {}).__kaching_bundles || 'null'); } catch (e) { return null; }
  };
  function anotarKaching(data, completo) {
    const items = data && (Array.isArray(data.items) ? data.items : (data.key ? [data] : null));
    if (!items) return;
    if (completo) conKaching.clear();
    // solo la línea principal sin grupo (tramo 1 o unidades sueltas): un tramo ya repartido lleva "id" de grupo
    items.forEach((i) => { const k = kb(i) || {}; if (k.main && !k.id) conKaching.add(i.key); });
    mostrarSubidas();
  }
  function mostrarSubidas() {
    document.querySelectorAll('[data-gpc-up]').forEach((b) => {
      if (conKaching.has(b.dataset.key)) b.hidden = false;
    });
  }

  async function post(path, body) {
    // tiempo límite: una petición colgada no puede bloquear la cola (red móvil mala)
    const ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    const limite = ctrl ? setTimeout(() => ctrl.abort(), 12000) : 0;
    let response;
    try {
      response = await window.gpcFetchOriginal(url(path), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ ...body, sections: sections(), sections_url: window.location.pathname }),
        ...(ctrl ? { signal: ctrl.signal } : {}),
      });
    } finally {
      clearTimeout(limite);
    }
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || state.message || `HTTP ${response.status}`);
    anotarKaching(state, path.indexOf('add') === -1);
    return state;
  }

  // como renderContents del tema pero sin abrir el cajón y conservando el scroll
  function paint(state) {
    const d = drawer();
    if (!d || !state || !state.sections) return;
    const scroll = document.querySelector('#CartDrawer .gpc__body')?.scrollTop || 0;
    d.getSectionsToRender().forEach((section) => {
      const html = state.sections[section.section || section.id];
      const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (html && el) el.innerHTML = d.getSectionInnerHTML(html, section.selector);
    });
    const body = document.querySelector('#CartDrawer .gpc__body');
    if (body && scroll) body.scrollTop = scroll;
    const p = pagina();
    if (p && state.sections[p.id]) {
      const nuevo = new DOMParser().parseFromString(state.sections[p.id], 'text/html').querySelector('[data-gpc-pagina]');
      if (nuevo) p.el.innerHTML = nuevo.innerHTML;
    }
    if (typeof state.item_count === 'number') d.classList.toggle('is-empty', state.item_count === 0);
    else d.classList.remove('is-empty');
    mostrarSubidas();
    // el repintado cambia el fondo oscuro: se vuelve a enganchar "pulsar fuera cierra" como hace renderContents
    const overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay && !overlay.dataset.gpcCierra) {
      overlay.dataset.gpcCierra = '1';
      overlay.addEventListener('click', () => d.close());
    }
  }

  // --- al instante: importes en pantalla ---
  function money(cents) {
    const r = raiz();
    const currency = (r && r.dataset.moneda) || (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }
  function ajustar(dTotal, dAhorro, desde) {
    const r = (desde && desde.closest('.gpc')) || raiz();
    if (!r) return;
    const total = Math.max(0, Number(r.dataset.total) + dTotal);
    const ahorro = Math.max(0, Number(r.dataset.ahorro) + dAhorro);
    const umbral = Number(r.dataset.umbral) || 0;
    r.dataset.total = total;
    r.dataset.ahorro = ahorro;
    r.querySelectorAll('[data-gpc-total]').forEach((el) => { el.textContent = money(total); });
    const antes = r.querySelector('[data-gpc-antes]');
    if (antes) {
      antes.hidden = ahorro <= 0;
      antes.textContent = money(total + ahorro);
    }
    const save = r.querySelector('[data-gpc-save]');
    if (save) {
      save.hidden = ahorro <= 0;
      const t = save.querySelector('[data-gpc-save-t]');
      if (t) t.textContent = (r.dataset.ahorroTxt || '').replace('[amount]', money(ahorro));
    }
    if (umbral > 0) {
      const falta = umbral - total;
      const bar = r.querySelector('[data-gpc-bar]');
      if (bar) bar.style.width = `${Math.min(100, Math.max(0, (total / umbral) * 100))}%`;
      const ship = r.querySelector('[data-gpc-ship]');
      if (ship) ship.classList.toggle('is-ok', falta <= 0);
      const msg = r.querySelector('[data-gpc-ship-t]');
      if (msg) {
        const b = document.createElement('b');
        if (falta > 0) {
          const [a, d] = (r.dataset.faltaTxt || '').split('[amount]');
          b.textContent = money(falta);
          msg.replaceChildren(document.createTextNode(a || ''), b, document.createTextNode(d || ''));
        } else {
          b.textContent = r.dataset.okTxt || '';
          msg.replaceChildren(b);
        }
      }
      const hint = r.querySelector('[data-gpc-hint]');
      if (hint) hint.hidden = falta <= 0;
      r.querySelectorAll('[data-gpc-envio]').forEach((el) => { el.hidden = falta > 0; });
    }
  }
  const n = (el, k) => Number(el && el.dataset[k]) || 0;

  // --- cola: una acción detrás de otra; solo se repinta con la última respuesta ---
  let cola = Promise.resolve();
  let forzar = false;
  let enCola = 0;
  let pending = 0; // mutaciones nuestras en vuelo: mientras tanto no se revisa ni se sincroniza
  function encolar(fn) {
    enCola += 1;
    pending += 1;
    const p = cola.then(async () => {
      try {
        const state = await fn();
        if (enCola === 1) paint(state); // si detrás viene otra, se repinta con la suya
      } catch (e) {
        console.error('[gp-cart]', e);
        forzar = true; // si algo falló, el cajón se repinta con lo que diga Shopify (deshace lo pintado al instante)
        pedirSync(50);
      } finally {
        enCola -= 1;
        pending -= 1;
        schedule();
      }
    });
    cola = p;
    return p;
  }

  const add = (variant, properties) => encolar(() => post('cart/add.js', { items: [{ id: Number(variant), quantity: 1, ...(properties ? { properties } : {}) }] }));
  const setQty = (keys, quantity) => {
    const updates = {};
    String(keys).split(',').filter(Boolean).forEach((k) => { updates[k] = quantity; });
    return encolar(() => post('cart/update.js', { updates }));
  };

  // quita las claves pintadas y, además, toda línea de esa variante que no sea un complemento: si antes iba una
  // subida de tramo, Kaching ha partido la línea y la clave nueva no estaba en el HTML
  function quitarGrupo(btn) {
    const vid = Number(btn.dataset.variant);
    const pintadas = String(btn.dataset.gpcQuitar).split(',').filter(Boolean);
    return encolar(async () => {
      const cart = await window.gpcFetchOriginal(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const hay = new Set(cart.items.map((i) => i.key));
      const updates = {};
      pintadas.filter((k) => hay.has(k)).forEach((k) => { updates[k] = 0; });
      cart.items.forEach((i) => { if (i.variant_id === vid && !(i.properties || {})._gp_par) updates[i.key] = 0; });
      return post('cart/update.js', { updates });
    });
  }

  function quitarTarjeta(li) {
    if (!li || li.dataset.quitando) return false;
    li.dataset.quitando = '1';
    ajustar(-n(li, 'final'), -(n(li, 'antes') - n(li, 'final')), li);
    li.style.transition = 'opacity .2s';
    li.style.opacity = '0';
    li.style.pointerEvents = 'none';
    return true;
  }

  document.addEventListener('click', (event) => {
    const t = event.target instanceof Element ? event.target : null;
    if (!t) return;
    const rm = t.closest('[data-gpc-quitar]');
    if (rm) {
      event.preventDefault();
      if (quitarTarjeta(rm.closest('.gpc__item'))) quitarGrupo(rm);
      return;
    }
    const up = t.closest('[data-gpc-up]');
    if (up) {
      event.preventDefault();
      if (up.getAttribute('aria-busy')) return;
      up.setAttribute('aria-busy', 'true');
      // el total nuevo es seguro (3 uds = 2 de pago), pero el reparto exacto lo pone Kaching: importes en gris
      ajustar(n(up, 'delta'), n(up, 'dahorro'), up);
      const r = up.closest('.gpc');
      if (r) r.setAttribute('data-calculando', '');
      setQty(up.dataset.key, Number(up.dataset.qty) || 3);
    }
  });

  // casillas de complementos y protección: el input real está dentro de la etiqueta
  document.addEventListener('change', (event) => {
    const input = event.target instanceof HTMLInputElement ? event.target : null;
    if (!input || !input.classList.contains('gpc__cbx')) return;
    event.stopPropagation(); // que no llegue al onChange de cantidades del tema
    const row = input.closest('[data-gpc-par], [data-gpc-prot]');
    if (!row) return;
    // doble toque mientras la fila espera a Shopify: se ignora (la línea aún no tiene clave para quitarla)
    if (row.dataset.gpcBusy) {
      input.checked = !input.checked;
      return;
    }
    row.dataset.gpcBusy = '1';
    row.classList.toggle('is-on', input.checked);
    const signo = input.checked ? 1 : -1;
    if (row.matches('[data-gpc-prot]')) {
      ajustar(signo * n(row, 'price'), 0, row);
      const r = raiz();
      if (input.checked) {
        store.set(OFF, '');
        if (r) r.dataset.protOn = '1';
        encolar(() => post('cart/add.js', { items: [{ id: Number(row.dataset.variant), quantity: 1 }], attributes: { _gpc_prot_off: '' } }));
      } else {
        // quitada por el cliente: no vuelve en esta pestaña (sessionStorage) ni en otra (atributo del carrito)
        store.set(OFF, '1');
        if (r) r.dataset.protOn = '0';
        const updates = {};
        String(row.dataset.key).split(',').filter(Boolean).forEach((k) => { updates[k] = 0; });
        encolar(() => post('cart/update.js', { updates, attributes: { _gpc_prot_off: '1' } }));
      }
      return;
    }
    const precio = n(row, 'price');
    const cmp = n(row, 'cmp');
    ajustar(signo * precio, signo * (Math.max(cmp, precio) - precio), row);
    if (input.checked) add(row.dataset.variant, { _gp_par: '1' });
    else setQty(row.dataset.key, 0);
  }, true);

  // --- pagar: nunca con cambios sin guardar (lo que se cobra es lo que se ve) ---
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.gpc')) return;
    if (!pending && !protEnVuelo) return;
    event.preventDefault();
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    const esperar = async () => {
      for (let i = 0; i < 40 && (pending || protEnVuelo); i += 1) { await cola; await new Promise((r) => setTimeout(r, 100)); }
      // el repintado ha podido cambiar el formulario: se va al checkout directamente
      window.location.assign(url('checkout'));
    };
    esperar();
  }, true);

  // --- protección dentro del "Add To Cart" de la ficha (o de cualquier /cart/add de otros) ---
  let protEnVuelo = false;
  function protPendiente() {
    const r = raiz();
    if (!r || !r.dataset.protVariant || r.dataset.protOn === '1' || r.dataset.protAuto !== '1' || store.get(OFF) || protEnVuelo) return null;
    return r.dataset.protVariant;
  }
  function conProteccion(init) {
    const variant = protPendiente();
    if (!variant || !init || !init.body) return init;
    let body = init.body;
    try {
      if (body instanceof FormData) {
        // copia: el FormData original no se toca (el tema y otras apps lo leen después)
        const copia = new FormData();
        for (const [k, v] of body.entries()) copia.append(k, v);
        body = copia;
        init = { ...init, body };
        if (body.has('items[0][id]')) {
          let i = 0;
          while (body.has(`items[${i}][id]`)) i += 1;
          body.append(`items[${i}][id]`, variant);
          body.append(`items[${i}][quantity]`, '1');
        } else if (body.get('id')) {
          // un solo producto (formulario de la ficha): se pasa a items[] para añadir los dos en la misma petición
          body.append('items[0][id]', body.get('id'));
          body.append('items[0][quantity]', body.get('quantity') || '1');
          [...body.entries()].filter(([k]) => k.startsWith('properties[')).forEach(([k, v]) => {
            body.append(`items[0][properties]${k.slice('properties'.length)}`, v);
            body.delete(k);
          });
          if (body.get('selling_plan')) body.append('items[0][selling_plan]', body.get('selling_plan'));
          ['id', 'quantity', 'selling_plan'].forEach((k) => body.delete(k));
          body.append('items[1][id]', variant);
          body.append('items[1][quantity]', '1');
        } else {
          return init;
        }
      } else if (typeof body === 'string' && body.trim().startsWith('{')) {
        const json = JSON.parse(body);
        if (Array.isArray(json.items)) json.items.push({ id: Number(variant), quantity: 1 });
        else if (json.id) {
          const { id, quantity, properties, selling_plan: plan, ...resto } = json;
          json.items = [{ id, quantity: quantity || 1, ...(properties ? { properties } : {}), ...(plan ? { selling_plan: plan } : {}) }, { id: Number(variant), quantity: 1 }];
          Object.keys(json).forEach((k) => { if (!(k in resto) && k !== 'items') delete json[k]; });
        } else return init;
        init = { ...init, body: JSON.stringify(json) };
      } else {
        return init;
      }
      const r = raiz();
      if (r) r.dataset.protOn = '1';
      init.gpcProteccion = true;
    } catch (e) {
      console.error('[gp-cart] protección en el añadir', e);
    }
    return init;
  }

  function revisar() {
    if (pending) return;
    mostrarSubidas();
    // 1) si en el carrito solo queda la protección, se quita
    const huerfana = document.querySelector('[data-gpc-huerfana]:not([data-done])');
    if (huerfana) {
      document.querySelectorAll('[data-gpc-huerfana]').forEach((h) => h.setAttribute('data-done', '')); // cajón y página
      setQty(huerfana.dataset.key, 0);
      return;
    }
    // 2) red de seguridad: si un añadir no la llevó (XHR de una app), se pone ahora
    const auto = document.querySelector('[data-gpc-prot]:not(.is-on):not([data-done])');
    if (auto && protPendiente() && document.querySelector('#CartDrawer .gpc__item')) {
      document.querySelectorAll('[data-gpc-prot]').forEach((x) => x.setAttribute('data-done', ''));
      auto.classList.add('is-on');
      const input = auto.querySelector('.gpc__cbx');
      if (input) input.checked = true;
      ajustar(n(auto, 'price'), 0, auto);
      const r = raiz();
      if (r) r.dataset.protOn = '1';
      protEnVuelo = true;
      add(auto.dataset.variant).finally(() => { protEnVuelo = false; });
    }
  }

  // el añadir de la ficha puede repintar el cajón dos veces: se espera a que se calme
  let timer = 0;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(revisar, 300);
  }
  new MutationObserver((records) => {
    for (const r of records) {
      for (const node of r.addedNodes) {
        if (node.nodeType === 1 && (node.matches('.gpc, [data-gpc-huerfana], [data-gpc-prot], [data-gpc-up]') || node.querySelector('.gpc'))) {
          mostrarSubidas();
          schedule();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // --- Vigilancia del cajón frente a /cart.js ---
  const esCarrito = (u) => /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(u || ''));
  const esAnadir = (u) => /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(u || ''));
  let syncTimer = 0;
  let syncing = false;
  function pedirSync(ms = 600) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sincronizar, ms);
  }
  async function sincronizar() {
    if (syncing || pending) return pedirSync(400);
    syncing = true;
    try {
      const cart = await window.gpcFetchOriginal(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      if (pending) { pedirSync(400); return; }
      anotarKaching(cart, true);
      // regalos de Kaching sin su producto (el cliente lo quita desde otro sitio): fuera, si no se cobrarían enteros
      const grupos = new Set(cart.items.filter((i) => (kb(i) || {}).main).map((i) => kb(i).id));
      const huerfanos = cart.items.filter((i) => { const k = kb(i); return k && k.gift && !grupos.has(k.id); });
      if (huerfanos.length) {
        const updates = {};
        huerfanos.forEach((i) => { updates[i.key] = 0; });
        encolar(() => post('cart/update.js', { updates }));
        return;
      }
      // protección de más (dos pestañas, "atrás"): se deja una sola unidad
      const pv = Number(raiz()?.dataset.protVariant);
      const prots = pv ? cart.items.filter((i) => i.variant_id === pv) : [];
      if (prots.reduce((a, i) => a + i.quantity, 0) > 1) {
        const updates = {};
        prots.forEach((i, x) => { updates[i.key] = x === 0 ? 1 : 0; });
        encolar(() => post('cart/update.js', { updates }));
        return;
      }
      const enCarrito = `${cart.items.map((i) => `${i.key}:${i.quantity}`).join('|')}#${cart.total_price}`;
      const enCajon = raiz()?.dataset.firma || '';
      if (enCarrito === enCajon && !forzar) return;
      forzar = false;
      const r = await window.gpcFetchOriginal(`${window.location.pathname}?sections=${sections().join(',')}`, { headers: { Accept: 'application/json' } });
      const secciones = await r.json();
      if (pending) { pedirSync(400); return; }
      paint({ sections: secciones, item_count: cart.item_count });
      schedule();
    } catch (e) {
      console.error('[gp-cart] sincronizar', e);
    } finally {
      syncing = false;
    }
  }
  window.gpcFetchOriginal = window.gpcFetchOriginal || window.fetch.bind(window);
  window.fetch = function (input, init) {
    const u = input && input.url ? input.url : input;
    if (esAnadir(u)) init = conProteccion(init);
    const p = window.gpcFetchOriginal(input, init);
    if (init && init.gpcProteccion) {
      p.then((r) => { if (!r.ok) { const x = raiz(); if (x) x.dataset.protOn = '0'; } }, () => { const x = raiz(); if (x) x.dataset.protOn = '0'; });
    }
    if (esCarrito(u)) {
      // las respuestas del carrito traen las propiedades: así la subida de tramo sale sin esperar a /cart.js
      p.then((r) => r.clone().json().then((d) => anotarKaching(d, !esAnadir(u))).catch(() => {}), () => {});
      p.then(() => pedirSync(), () => pedirSync());
    }
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, u) {
    if (esCarrito(u)) this.addEventListener('loadend', () => pedirSync());
    return xhrOpen.apply(this, arguments);
  };
  // al abrir el cajón también se revisa
  const cd = drawer();
  if (cd) new MutationObserver(() => { if (cd.classList.contains('active')) pedirSync(50); }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  // y al cargar la página, por si el carrito llega descuadrado de otra visita
  pedirSync(800);
  // al volver con "atrás" (caché del navegador) o a esta pestaña después de tocar el carrito en otra
  window.addEventListener('pageshow', (e) => { if (e.persisted) { forzar = true; pedirSync(50); } });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') pedirSync(200); });
  schedule();
})();
